import BasePolicy from '@/policies/BasePolicy.js';

export default class ActivitySubmissionPolicy extends BasePolicy {
    /**
     *
     * @param {User} user
     * @param {Course} course
     * @returns {*}
     */
    viewOther(user, course) {
        return user.hasPermissionViaCourseTo(course, "view another user's activity submission");
    }

    /**
     *
     * @param {User} user
     * @param {Course} course
     * @returns {*}
     */
    viewAny(user, course) {
        return user.hasPermissionViaCourseTo(course, 'view an activity submission');
    }

    /**
     *
     * @param {User} user
     * @param {Course} course
     * @returns {*}
     */
    create(user, course) {
        return user.hasPermissionViaCourseTo(course, 'create an activity submission');
    }

    /**
     *
     * @param {User} user
     * @param {Course} course
     * @returns {*}
     */
    delete(user, course) {
        return user.hasPermissionViaCourseTo(course, 'delete an activity submission');
    }
}
